import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { CheckCircleSolidIcon } from '@fiverr-private/visuals';
import { Text } from '@fiverr-private/typography';
import * as styles from './styles.ve.css';

interface ProSectionPointProps {
  text: string;
}

export default function ProSectionPoint({ text }: ProSectionPointProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      flexBasis={{ md: '45%', lg: 'max-content' }}
      flexGrow={{ md: 1, lg: 0 }}
      gap={{ default: '2', sm: '3', lg: '2' }}
      className={styles.proSectionPointItem}
    >
      <Container hidden={{ default: false, sm: true }} width="18px" height="18px">
        <CheckCircleSolidIcon color="black" size="sm" />
      </Container>
      <Container hidden={{ default: true, sm: false }} width="24px" height="24px">
        <CheckCircleSolidIcon color="black" size="lg" />
      </Container>
      <Text size={{ default: 'b_md', sm: 'b_lg', lg: 'b_sm', xl: 'b_md' }} className={styles.proSectionPointText}>
        {text}
      </Text>
    </Stack>
  );
}
